module.exports = __webpack_public_path__ + "static/media/CTA5.ef01b86b.avif";